export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/30 via-background-50 to-accent-100/20 pointer-events-none"></div>

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-[72px] pb-16 md:pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              一站式韩漫入口导航
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              韩漫
              <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-foreground-700 mt-1">
                韩漫漫画网址导航与在线观看汇总平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-6">
              汇集全网热门韩漫网站、韩漫网、韩漫之家与韩漫屋等优质平台入口，提供免费韩漫漫画网址导航与在线观看汇总。
              <span className="block mt-2">
                每日更新热门韩漫资源，覆盖恋爱、奇幻、热血、悬疑等多元题材，方便漫迷集中浏览与收藏，是您发现和追踪韩漫内容的首选导航聚合。
              </span>
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">200+</div>
                <div className="text-xs text-foreground-500 mt-1">收录平台</div>
              </div>
              <div className="w-px h-12 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">15类</div>
                <div className="text-xs text-foreground-500 mt-1">题材覆盖</div>
              </div>
              <div className="w-px h-12 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">每日</div>
                <div className="text-xs text-foreground-500 mt-1">持续更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                开始浏览
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-md hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer text-sm"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                热门推荐
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20cozy%20reading%20scene%20with%20a%20modern%20tablet%20displaying%20colorful%20comic%20panels%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20surrounded%20by%20manga%20books%20and%20a%20cup%20of%20coffee%2C%20soft%20cream%20and%20warm%20beige%20background%2C%20illustration%20style%20with%20gentle%20gradients%2C%20cozy%20atmosphere%2C%20artistic%20composition%2C%20high%20detail&width=960&height=1200&seq=hero-manhwa-2026&orientation=portrait"
                alt="韩漫在线观看导航汇总 - 韩漫漫画网站大全"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <a
          href="#index"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex flex-col items-center gap-2 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
        >
          <span className="text-xs">向下浏览</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}